import React from "react";
import { Text } from "react-native-paper";
import { StyleSheet, View, Image, Dimensions } from "react-native";
import {
  whiteColor,
  greyColor,
  blackColor,
  greenBold,
} from "./../../common/colors";
import blueParrot from "../AboutColor/blueParrot.png";
import yellowParrot from "../AboutColor/yellowParrot.png";
import greenParrot from "../AboutColor/greenParrot.png";
import redParrot from "../AboutColor/redParrot.png";
import DominateColor from "../../common/DominateColor";
import windowWidth from "../../common/windowWidth";
import { blockColor } from "../../common/colors";
import { COLOR_TYPES } from "../../common/helpers/onlyTwoDominateColors";
const ParrotBox = (props) => {
  const getImage = (colorType) => {
    switch (colorType) {
      case COLOR_TYPES.RED:
        return redParrot;
      case COLOR_TYPES.BLUE:
        return blueParrot;
      case COLOR_TYPES.YELLOW:
        return yellowParrot;
      case COLOR_TYPES.GREEN:
        return greenParrot;
    }
  };

  return (
    <View style={styles.wrapper}>
      <View style={styles.item1}>
        <Image
          source={getImage(props.dominate.colorType)}
          style={styles.image}
        />
      </View>
      <View style={styles.item2}>
        <DominateColor dominate={props.dominate} i={1} style={styles.block} />
      </View>
    </View>
  );
};
export default ParrotBox;

const styles = StyleSheet.create({
  wrapper: {
    borderColor: greyColor,
    width: 274,
    height: 103,
    backgroundColor: whiteColor,
    flexDirection: "row",
    borderWidth: 1,
    borderRadius: 3,
  },
  item1: {
    width: "50%",
    height: 103,
    justifyContent: "flex-start",
  },
  item2: {
    width: "50%",
    height: 103,
  },
  image: {
    marginTop: 0,
    height: 103,
    resizeMode: "contain",
  },
  block: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    width: "100%",
    height: 101,
    backgroundColor: whiteColor,
    borderRadius: 0,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 0,
  },
});
